/* eslint-disable */
// Package Imports
import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import { createRoot } from 'react-dom/client';

// Project Imports
import keycloak from 'keycloak/keyCloak';
import App from 'App';
import 'i18n';
import TokenProvider from 'contexts/resource/ResourceContext';
import useLogger from 'core/utils/useLogger';
import SocketNotificationProvider from 'contexts/socketNotificationContext/SocketNotificationContext';
import { REACT_APP_ENV } from 'config';
import axiosInstance from 'providers/axiosInstance/axiosInstance';
import 'assets/styles/field.css';
import 'assets/styles/notification.css';
import TaskConfigProvider from 'contexts/taskConfigContext/TaskConfigContext';

declare global {
  interface Window {
    REACT_APP_ENV: string;
    REACT_APP_KEYCLOAK_REALM: string;
    REACT_APP_KEYCLOAK_URL: string;
    REACT_APP_KEYCLOAK_CLIENT_ID: string;
    REACT_APP_API_URL: string;
    REACT_APP_API_PAYOUT_URL: string;
    REACT_APP_API_URL_ORG: string;
    REACT_APP_API_URL_ROLE_PERM: string;
    REACT_APP_API_URL_INPUT_SOURCE: string;
    REACT_APP_API_URL_FREQUENCY_MANAGEMENT: string;
    REACT_APP_API_URL_WORKFLOW_MANAGEMENT: string;
    REACT_APP_API_URL_PROGRAM: string;
    REACT_APP_API_URL_UNIFIED: string;
    REACT_APP_API_URL_MASTER: string;
    REACT_APP_USER_API_URL: string;
    REACT_APP_MY_TASK_API_URL: string;
    REACT_APP_API_URL_RULE: string;
    REACT_APP_API_URL_SIMULATION_MANAGEMENT: string;
    REACT_APP_API_URL_REPORT_MANAGEMENT: string;
    REACT_APP_FORM_BASE_URL: string;
    REACT_APP_SOCKET_URL: string;
    REACT_APP_API_URL_DASHBOARD_MANAGEMENT: string;
    REACT_APP_API_URL_TARGET_MANAGEMENT: string;
  }
}

const waitForWindowConfig = () =>
  new Promise((resolve) => {
    const check = () => {
      if (window.REACT_APP_ENV || process.env.REACT_APP_ENV) {
        resolve(true);
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });

waitForWindowConfig().then(() => {
  console.log('Config loaded:', {
    ENV: REACT_APP_ENV,
  });

  const container = document.getElementById('root');
  const keycloakInitOptions = {
    onLoad: 'login-required',
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    pkceMethod: 'S256',
    checkLoginIframe: false,
    responseMode: 'query',
  };
  const eventLogger = (event: string) => {
    if (event === 'onAuthRefreshError') {
      keycloak.logout();
    }
  };

  const tokenLogger = (tokens: { token?: string }) => {
    if (tokens?.token) {
      axiosInstance.defaults.headers.common.Authorization = `Bearer ${tokens.token}`;
    } else {
      delete axiosInstance.defaults.headers.common.Authorization;
    }
  };
  const logger = useLogger();
  if (container) {
    const root = createRoot(container);
    root.render(
      <TokenProvider>
        <SocketNotificationProvider>
          <TaskConfigProvider>
            <ReactKeycloakProvider
              authClient={keycloak}
              onEvent={eventLogger}
              onTokens={tokenLogger}
              initOptions={keycloakInitOptions}
            >
              <React.StrictMode>
                <React.Suspense fallback="loading">
                  <App />
                </React.Suspense>
              </React.StrictMode>
            </ReactKeycloakProvider>
          </TaskConfigProvider>
        </SocketNotificationProvider>
      </TokenProvider>
    );
  } else {
    logger('Root element with id', '');
  }
});
